// src/components/FadeSection.jsx
import React from 'react';
import { motion } from 'framer-motion';

const FadeSection = ({ children, delay = 0, id }) => {
  return (
    <motion.section
      id={id}
      initial={{ opacity: 0, y: 40 }} // 移動距離を100→40に減らし、上品に
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }} // 画面に少し入ってから開始
      transition={{ 
        duration: 1.2, // 時間をかけてゆっくり
        ease: [0.22, 1, 0.36, 1], // "easeOutQuart"のようなしっとりした動き
        delay: delay 
      }}
      style={{ position: 'relative', marginBottom: '80px' }} // セクション間の余白も確保
    >
      {children}
    </motion.section>
  );
};

export default FadeSection;